import { ActivityRisk } from './activity-risk.interface';
import { ActivityRiskService } from './activity-risk.service';
const service = new ActivityRiskService();

export interface ActivityRiskState {
   activityRisks: Array<ActivityRisk>;
}

const state = {
   activityRisks: [],
};

const getters = {
   activityRisks(state: ActivityRiskState) {
      return state.activityRisks;
   },
};

const mutations = {
   SET_ACTIVITY_RISKS(state: ActivityRiskState, newValue: Array<ActivityRisk>) {
      state.activityRisks = newValue;
   },
};

const actions = {
   async getActivityRisks(context: any) {
      return await service.getActivityRisks().then((response) => {
         context.commit('SET_ACTIVITY_RISKS', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
